
import LayoutContent from '../../components/layouts/content2';
import React, {useState, useEffect} from 'react';
import ListProducts from './ListProducts';
import {useTranslation} from 'react-i18next';
import { getData } from '../../helpers/indexedDbHelper';
import SpecialsScreen from './specials';
import TequilaScreen from './tequila';
import MezcalCocktail from './mezcal';
import WhiskeyScreen from './whiskey';
import VodkaScreen from './vodka';
import GinScreen from './gin';
import RumScreen from './rum';
import CognacScreen from './cognac';
import AppertifScreen from './appertif';
import PiscoScreen from './pisco';
import WhiskeyCatScreen from './whiskeycat';

function Index({dishs2, setShowListProduct2, goHome}) { 

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;

    const [menus, setMenus] = useState([]);
    const [showSpecials, setShowSpecials] = useState(false);
    const [showMezal, setShowMezal] = useState(false);
    const [showTequila, setShowTequila] = useState(false);
    const [showWhiskey, setshowWhiskey] = useState(false);
    const [showVodka, setshowVodka] = useState(false);
    const [showGin, setShowGin] = useState(false);
    const [showRum, setShowRum] = useState(false);
    const [showCognac, setShowCognac] = useState(false);
    const [showAppetif, setShowAppetif] = useState(false);
     const [showPisco, setshowPisco] = useState(false);
     const [showWhiskeyCat, setshowWhiskeyCat] = useState(false);
    const [showListProduct, setShowListProduct] = useState(false);
    const [dishs, setdishs] = useState(false);

    const [datachampana, setdatachampana] = useState(false);
    const [datawine, setdatawine] = useState(false);

     useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
            setMenus(data);
        });
     }, []);
    
    
    useEffect(() => {
        menus.map((item) => {
            if (item.id === 341) {
                setdatachampana(item);
            }
            if (item.id === 340) {
                setdatawine(item);
            }
        });
    }, [menus]);
    
    
    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent showBack={true} setShowListProduct={setShowListProduct2} setShowSpecials={setShowSpecials} goHome={goHome}>
                <div style={{ padding: '0 20px' }}>
                    <img
                         onContextMenu={(e) => e.preventDefault()}
                        src={require('./assets/top.png')}
                        style={{
                        objectFit: 'contain',
                        width: '100%',
                            height: 140,
                          pointerEvents: 'none',
                        marginTop: -10,
                        }}
                    />
                     <p style={{color: 'white', textAlign: 'center', fontSize: 35, marginTop: -30}}>
                        SPIRITS
                    </p>
                    <div
                        
                        style={{
                            display: 'flex',
                            marginTop: 10,
                            flexDirection: 'row',
                            alignSelf: 'center',
                            justifyContent: "center"
                        }}>
                        <div
                            onClick={()=>setShowTequila(true)}
                            style={{
                            display: 'flex',
                            justifyContent: 'center',
                                alignItems: 'center',
                            position: 'relative'
                        }}>
                            <img
                                  onContextMenu={(e) => e.preventDefault()}
                                src={require('./assets/bk.png')}
                                style={{
                                    objectFit: 'contain',
                                    width: 200,
                                    height: 120,
                                     pointerEvents: 'none',
                                }}
                            />
                            <div style={{position: 'absolute'}}>
                                <p
                                    style={{color: 'white', textAlign: 'center', fontSize: 17}}>
                                    TEQUILA
                                </p>
                            </div>
                        </div>

                        <div
                           onClick={()=>setShowMezal(true)}
                            style={{
                                 display: 'flex',
                            justifyContent: 'center',
                                alignItems: 'center',
                            position: 'relative'
                            }}>
                            <img
                                 onContextMenu={(e) => e.preventDefault()}
                            src={require('./assets/bk.png')}
                            style={{
                                resizeMode: 'contain',
                                width: 200,
                                height: 120,
                                 pointerEvents: 'none',
                            }}
                            />
                            <div style={{position: 'absolute'}}>
                                <p
                                    style={{color: 'white', textAlign: 'center', fontSize: 17}}>
                                    MEZCAL
                                </p>
                            </div>
                        </div>
                    </div>

                    <div
                        style={{
                            display:'flex',
                            flexDirection: 'row',
                            alignSelf: 'center',
                            justifyContent: 'center'
                        }}>
                        <div
                            onClick={() => {
                                setshowWhiskeyCat(true)
                             }}
                            style={{
                                display: 'flex',
                                position: 'relative',
                            justifyContent: 'center',
                            alignItems: 'center',
                            }}>
                            <img
                                 onContextMenu={(e) => e.preventDefault()}
                                src={require('./assets/bk.png')}
                                style={{
                                    resizeMode: 'contain',
                                    width: 200,
                                    height: 120,
                                     pointerEvents: 'none',
                            }}
                            />
                            <div style={{position: 'absolute'}}>
                                <p
                                    style={{color: 'white', textAlign: 'center', fontSize: 17}}>
                                    WHISKEY
                                </p>
                            </div>
                        </div>

                        <div
                             onClick={()=>setshowVodka(true)}
                            style={{
                                 display:'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}>
                            <img
                                src={require('./assets/bk.png')}
                                style={{
                                    resizeMode: 'contain',
                                    width: 200,
                                    height: 120,
                                }}
                            />
                            <div style={{position: 'absolute'}}>
                            <p
                                style={{color: 'white', textAlign: 'center', fontSize: 17}}>
                                VODKA
                            </p>
                            </div>
                        </div>
                    </div>
                     <div
                       
                        style={{
                            display: "flex",
                            flexDirection: 'row',
                            alignSelf: 'center',
                            justifyContent: "center"
                        }}>
                        <div
                             onClick={() => setShowGin(true)}
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                position: 'relative'
                            }}>
                            <img
                                src={require('./assets/bk.png')}
                                style={{
                                    objectFit: 'contain',
                                    width: 200,
                                    height: 120,
                                }}
                            />
                            <div style={{position: 'absolute'}}>
                            <p
                                style={{color: 'white', textAlign: 'center', fontSize: 17}}>
                                GIN
                            </p>
                            </div>
                        </div>

                        <div
                           onClick={() => setShowRum(true)}
                            style={{
                                display: "flex",
                                justifyContent: 'center',
                                alignItems: 'center',
                                position: 'relative'
                            }}>
                            <img
                                src={require('./assets/bk.png')}
                                style={{
                                    resizeMode: 'contain',
                                    width: 200,
                                    height: 120,
                                }}
                            />
                            <div style={{position: 'absolute'}}>
                            <p
                                style={{color: 'white', textAlign: 'center', fontSize: 15}}>
                                RUM
                            </p>
                            </div>
                        </div>
                    </div>

                    <div
                       
                        style={{
                            display: "flex",
                            flexDirection: 'row',
                            alignSelf: 'center',
                            justifyContent: "center"
                        }}>
                        <div
                             onClick={() => setShowCognac(true)}
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                position: 'relative'
                            }}>
                            <img
                                src={require('./assets/bk.png')}
                                style={{
                                    objectFit: 'contain',
                                    width: 200,
                                    height: 120,
                                }}
                            />
                            <div style={{position: 'absolute'}}>
                            <p
                                style={{color: 'white', textAlign: 'center', fontSize: 17}}>
                                 COGNAC/ BRANDY
                            </p>
                            </div>
                        </div>

                        <div
                            onClick={() => setShowAppetif(true)}
                            style={{
                                display: "flex",
                                justifyContent: 'center',
                                alignItems: 'center',
                                position: 'relative'
                            }}>
                            <img
                                src={require('./assets/bk.png')}
                                style={{
                                    resizeMode: 'contain',
                                    width: 200,
                                    height: 120,
                                }}
                            />
                            <div style={{position: 'absolute'}}>
                            <p
                                style={{color: 'white', textAlign: 'center', fontSize: 15}}>
                                 APPERITIF/ DIGESTIF
                            </p>
                            </div>
                        </div>
                    </div>
                     <div
                        style={{
                            display:"flex",
                            flexDirection: 'row',
                            alignSelf: 'center',
                            justifyContent: 'center'
                        }}>
                        <div
                            onClick={()=>setshowPisco(true)}
                            style={{
                                display:"flex",
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}>
                            <img
                                src={require('./assets/bk.png')}
                                style={{
                                    resizeMode: 'contain',
                                    width: 200,
                                    height: 120,
                                }}
                            />
                            <div style={{position: 'absolute'}}>
                                <p
                                    style={{color: 'white', textAlign: 'center', fontSize: 17}}>
                                    PISCO
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                
                {showSpecials && <SpecialsScreen setShowHappy={goHome} setShowListProduct={setShowSpecials}  />}
                {showTequila && <TequilaScreen setShowListProduct={setShowTequila} goHome={goHome} />}
                {showMezal && <MezcalCocktail setShowListProduct={setShowMezal} goHome={goHome} />}
                {showWhiskey && <WhiskeyScreen setShowListProduct={setshowWhiskey} goHome={goHome} />}
                {showVodka && <VodkaScreen setShowListProduct={setshowVodka} goHome={goHome} />}
                {showGin && <GinScreen setShowListProduct={setShowGin} goHome={goHome} />}
                {showRum && <RumScreen setShowListProduct={setShowRum} goHome={goHome} />}
                {showCognac && <CognacScreen setShowListProduct={setShowCognac} goHome={goHome} />}
                {showAppetif && <AppertifScreen setShowListProduct={setShowAppetif} goHome={goHome} />}
                {showPisco && <PiscoScreen setShowListProduct={setshowPisco} goHome={goHome} />}
                {showWhiskeyCat && <WhiskeyCatScreen setShowListProduct2={setshowWhiskeyCat} goHome={goHome} />} 

                
                
                {showListProduct && <ListProducts
                    dishs={dishs}
                    setShowListProduct={false}
                />}
                
            </LayoutContent>
        </div>
    );
}
export default Index;